const inputs = document.getElementsByClassName('active-tag-input');

if (inputs.length > 0) {

    for (let elemento of inputs) {
        elemento.addEventListener("change", function (event) {
            activeTagInput(elemento)
        });
    }
}

function activeTagInput(elemento) {
    const tag_name = elemento.getAttribute('data-input-name');
    const value = elemento.value;
    const params = new URLSearchParams(window.location.search);

    if (value !== "") {
        document.getElementById(`tag_${tag_name}`).setAttribute('style', 'display:block;');
        document.getElementById(`tag_content_${tag_name}`).textContent = value;
        params.set(tag_name, value);
    } else {
        document.getElementById(`tag_${tag_name}`).setAttribute('style', 'display:none;');
        document.getElementById(`tag_content_${tag_name}`).textContent = '';
        params.delete(tag_name);
    }

    const newUrl = window.location.pathname + '?' + params.toString();
    window.history.replaceState(null, '', newUrl);
}

const multiple = document.getElementsByClassName('active-tag-multiple');

if (multiple.length > 0) {
    for (let elemento of multiple) {
        elemento.addEventListener("change", function (event) {
            const tag_name = this.getAttribute('data-input-name');
            const formulario = this.closest('form');
            const group = this.closest('.form-group');
            let selector = group.getElementsByClassName('dropdown-toggle');
            selector = selector[0];

            if (elemento.value === 'TODOS') {
                if (elemento.checked) {
                    formulario.querySelectorAll(`input[name="${tag_name}[]"]`).forEach(function (item) {
                        if (item.value !== 'TODOS') {
                            item.checked = false;
                            item.setAttribute('disabled', 'disabled');
                        }
                    });
                } else {
                    formulario.querySelectorAll(`input[name="${tag_name}[]"]`).forEach(function (item) {
                        if (item.value !== 'TODOS') {
                            item.removeAttribute('disabled');
                        }
                    });
                }
            }

            const multiple_values = [];
            formulario.querySelectorAll(`input[name="${tag_name}[]"]:checked`).forEach(function (item) {
                multiple_values.push(item.value);
            });

            const params = new URLSearchParams(window.location.search);
            const value = multiple_values.toString()

            document.getElementById(`tag_content_${tag_name}`).textContent = value;

            if (multiple_values.length) {
                selector.textContent = multiple_values.toString();
                selector.classList.remove('selection-empty');
                document.getElementById(`tag_${tag_name}`).setAttribute('style', 'display:block;');
                params.set(tag_name, value);
            } else {
                selector.textContent = 'Selecciona';
                selector.classList.add('selection-empty');
                document.getElementById(`tag_${tag_name}`).setAttribute('style', 'display:none;');
                params.delete(tag_name);
            }

            const newUrl = window.location.pathname + '?' + params.toString();
            window.history.replaceState(null, '', newUrl);

        });
    }
}

const estadisticaSelects = document.getElementsByClassName('form-estadistica-select');

if (estadisticaSelects.length > 0) {
    for (let elemento of estadisticaSelects) {
        elemento.addEventListener("change", function (event) {

            if (this.value !== '') {
                this.classList.remove('selection-empty');
            } else {
                this.classList.add('selection-empty');
            }

        });
    }
}



const clear = document.getElementsByClassName('active-tag-clear');

if (clear.length > 0) {
    for (let elemento of clear) {
        elemento.addEventListener("click", function (event) {
            event.preventDefault();

            const formulario = this.closest('.filtros');
            const tag_clear_type = this.getAttribute('data-type');
            const tag_name = this.getAttribute('data-name');

            if (tag_clear_type === 'multiple') {
                formulario.querySelectorAll(`input[name="${tag_name}[]"]`).forEach(function (item) {
                    item.checked = false;
                });
            } else {
                console.log(`input_${tag_name}`);
                document.getElementById(`input_${tag_name}`).value = '';
                if (document.getElementById(`hdn_${tag_name}`)) {
                    document.getElementById(`hdn_${tag_name}`).value = '';
                }
            }

            document.getElementById(`tag_${tag_name}`).setAttribute('style', 'display:none;')
            document.getElementById(`tag_content_${tag_name}`).textContent = '';
            if (document.getElementById(`dropdown${tag_name}`)) {
                document.getElementById(`dropdown${tag_name}`).textContent = 'Selecciona';
            }

            const params = new URLSearchParams(window.location.search);
            params.delete(tag_name);

            const newUrl = window.location.pathname + '?' + params.toString();
            window.history.replaceState(null, '', newUrl);

        });
    }
}



const resetForm = document.getElementById('reset_form');
if(resetForm){
    resetForm.addEventListener("click", function (event) {
        let clear = document.getElementsByClassName('active-tag-clear');
        if (clear.length > 0) {
            for (let elemento of clear) {
                let tag_name = elemento.getAttribute('data-name');
                document.getElementById(`tag_${tag_name}`).setAttribute('style', 'display:none;')
                document.getElementById(`tag_content_${tag_name}`).textContent = '';

                if (document.getElementById(`dropdown${tag_name}`)) {
                    document.getElementById(`dropdown${tag_name}`).textContent = 'Selecciona';
                }
                document.querySelectorAll('select.form-estadistica-select').forEach(function (item) {
                    item.querySelectorAll('option').forEach(function (option) {
                        option.removeAttribute('selected');
                    });
                });
            }
        }

        const newUrl = window.location.pathname;
        window.location.href = newUrl;
    });
}


const formFiltros = document.getElementById('form_filtros_estadistica');

if (formFiltros) {
    formFiltros.addEventListener("submit", function (event) {
        event.preventDefault();

        const formFiltrosInputs = formFiltros.getElementsByTagName('input');
        const formFiltrosExtras = formFiltros.getElementsByTagName('select');
        let btn = document.getElementById("btn_form_filtros_estadistica");
        btn.innerHTML = `<i class="fas fa-spinner fa-spin"></i> Buscando`;
        btn.setAttribute('disabled',true);

        const formFiltrosValues = [];

        for (let input of formFiltrosInputs) {
            if (input.getAttribute('name') !== 'estado_domicilio[]') {
                const newArray = {};
                newArray[input.getAttribute('name')] = input.value;

                formFiltrosValues.push(newArray);
            }
        }

        for (let input of formFiltrosExtras) {
            const newArray = {};
            newArray[input.getAttribute('name')] = input.value;

            formFiltrosValues.push(newArray);
        }

        let estados_formulario = formFiltros.querySelectorAll('input[name="estado_domicilio[]"]');
        estados_formulario = Array.from(estados_formulario);

        let estados = [];
        estados_formulario.map(function (element) {
            if (element.checked) {
                estados.push(element.value);
            }
        });

        formFiltrosValues.push({'estado_domicilio[]' : estados});

        const objetoFormulario = Object.assign({}, ...formFiltrosValues.map((value) => (value)));

        fetch(`/estadistica/revisar`, {
            method: 'POST',
            body: JSON.stringify(objetoFormulario),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            if (response.status === 500) {
                btn.innerHTML = "Buscar";
                btn.removeAttribute("disabled");
            }
            return response.json();
        })
            .then(function (data) {
                if (data.success) {
                    document.getElementById('secc_respuesta').innerHTML = data.view;
                    if (data.downloadable) {
                        elementoDescargaArchivo();
                    }
                    paginadorEstadistica();
                }

                btn.innerHTML = "Buscar";
                btn.removeAttribute("disabled");
            });


    });
}

function elementoDescargaArchivo() {
    const descargaElemento = document.getElementById('secc_descarga_archivo');
    if (descargaElemento) {
        descargaElemento.addEventListener("click", function (event) {
            sendDownload();
        });
    }
}
paginadorEstadistica();

function paginadorEstadistica() {

    const paginacionEstadistica = document.getElementById('paginacion-estadistica');
    if (paginacionEstadistica) {
        paginacionEstadistica.querySelectorAll('a.page-link').forEach(function (item) {
            item.addEventListener("click", function (e) {
                e.preventDefault();

                const url = new URL(e.target.href);

                const inputPage = document.getElementById('input_page');
                inputPage.value = url.searchParams.get("page");

                const btnFormFiltros = document.getElementById('btn_form_filtros_estadistica');
                btnFormFiltros.click();

                const event = new Event("change");
                inputPage.dispatchEvent(event);

            });

        });
    }
}

const inputFechaConst = document.getElementById('input_fecha_constitucion');
const inputFechaAct = document.getElementById('input_fecha_actualizacion');

if (inputFechaConst && inputFechaAct) {
    inputFechaAct.addEventListener("change", function (event) {
        if (inputFechaAct.value !== '') {
            inputFechaConst.removeAttribute('required');
        } else {
            inputFechaConst.setAttribute('required', 'required');
        }
    });
}

if (inputFechaAct && inputFechaAct.value != '') {
    inputFechaConst.removeAttribute('required');
}

const tagFechaAct = document.getElementById('tag_fecha_actualizacion');
if (tagFechaAct && inputFechaConst) {


    tagFechaAct.querySelector('a').addEventListener("click", function (event) {
        inputFechaConst.setAttribute('required', 'required');
    });
}


sendDownload = function() {
    const formFiltros = document.getElementById('form_filtros_estadistica');
    formFiltros.submit();
}

let today = new Date();
let currentYear = today.getFullYear();
let currentMonth = today.getMonth();
let currentDay = today.getDate();

if(document.getElementById('input_fecha_presentacion_contrato')){
    new DateRangePicker('input_fecha_presentacion_contrato',{
        maxSpan: {
            months: meses_busqueda
        },
        maxDate: new Date(currentYear, currentMonth, currentDay),
    });
}

if(document.getElementById('input_fecha_registro')){
    new DateRangePicker('input_fecha_registro',{
        maxSpan: {
            months: meses_busqueda
        },
        maxDate: new Date(currentYear, currentMonth, currentDay),
    });
}

if(document.getElementById('input_fecha_actualizacion')){
    new DateRangePicker('input_fecha_actualizacion',{
        maxSpan: {
            months: meses_busqueda
        },
        maxDate: new Date(currentYear, currentMonth, currentDay),
    });
}

if(document.getElementById('input_fecha_constitucion')){
    new DateRangePicker('input_fecha_constitucion',{
        maxSpan: {
            months: meses_busqueda
        },
        maxDate: new Date(currentYear, currentMonth, currentDay),
    });
}

if(document.getElementById('input_inicio_vigencia_directiva')){
    new DateRangePicker('input_inicio_vigencia_directiva',{
        maxSpan: {
            months: meses_busqueda
        },
        maxDate: new Date(currentYear, currentMonth, currentDay),
    });
}

if(document.getElementById('input_fin_vigencia_directiva')){
    new DateRangePicker('input_fin_vigencia_directiva',{
        maxSpan: {
            months: meses_busqueda
        },
    });
}

window.addEventListener('apply.daterangepicker',function(e){
    const event = new Event("change");
    e.detail.element.dispatchEvent(event);
});

window.addEventListener('cancel.daterangepicker',function(e){
    const event = new Event("change");
    e.detail.element.dispatchEvent(event);
});
